/**
 * The runway's axis as pure functions: whole-day offsets from today and the
 * month starts inside the range.
 */
import dayjs from "dayjs";

const DAY_MS = 86_400_000;

const startOfDay = (d: Date): number =>
  new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();

/** Whole days from `today` to `date` (negative when past). */
export const dayOffset = (date: Date, today: Date): number =>
  Math.round((startOfDay(date) - startOfDay(today)) / DAY_MS);

/** Month starts inside `(today, today + days]`, as day offsets. */
export const monthTicks = (
  today: Date,
  days: number
): Array<{ offset: number; label: string }> => {
  const out: Array<{ offset: number; label: string }> = [];
  let m = dayjs(today).startOf("month").add(1, "month");
  while (dayOffset(m.toDate(), today) <= days) {
    out.push({
      offset: dayOffset(m.toDate(), today),
      label: m.month() === 0 ? m.format("MMM YYYY") : m.format("MMM")
    });
    m = m.add(1, "month");
  }
  return out;
};
